// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"menu-item_3sBnKc","menuItem":"menu-item_3sBnKc","edit":"edit_28sG6p"};